export const setLocationHash = (name: string) => {
    const location = document.location;
    location.assign(`${location.origin}${location.pathname}${location.search}${name}`);
    location.reload();
};
